export const roundUpToNearestTen = (numberToRound: number) => {
   return Math.ceil((numberToRound)/10)*10
}

export const roundDownToNearestTen = (numberToRound: number) => {
   return  Math.floor((numberToRound)/10)*10
}